<template>
  <v-card v-click-outside="unfocusEntireCard" class="d-flex flex-column flex-grow-1">
    <slotted-card :editable="true" :title="(JobDetails && JobDetails.OrderId) ? $t('servicesystem.common_objects.order.order') + ' ' + JobDetails.OrderId : 'Failed to load'"
      :icon="'$job'" :fontsize="'h4'" :headerclass="'pl-3'" :externalEditTrigger="edittrigger" @editMode="setEditMode"
      @valid="setValid">

      <template v-slot:content>
        <v-container class="pa-0" fluid>
          <v-list dense v-if="editObject" class="pb-0 pt-2">
            <v-row no-gutters>
              <v-col class="mx-3">
                <QTextField v-model="editObject.InvoiceReference"
                  :label="$t('servicesystem.common_objects.job.order_refrence')" :externaledit="editMode"
                  @FocusState="editMode ? null : edittrigger++">
                </QTextField>
              </v-col>
              <v-col class="mr-3">
                <QCheckboxInput v-model="editObject.NoInvoice"
                  :label="$t('servicesystem.common_objects.job.notbillable')" :externaledit="editMode"
                  :indeterminate="!!NonUniformNoInvoice" :boolcolors="{ indeterminate: 'secondary' }"
                  :booltexts="{ indeterminate: indeterminateText }" @FocusState="editMode ? null : edittrigger++"
                  :key="resettrigger">
                </QCheckboxInput>
              </v-col>
            </v-row>
            <v-divider class="my-2"></v-divider>
            <v-row no-gutters >
              <v-col class="mx-3">
                <DepartmentSelect v-model="editObject.DepartmentId"
                  :label="$t('servicesystem.common_objects.department.department')" clearable :externaledit="editMode" @FocusState="editMode ? null : edittrigger++" >
                </DepartmentSelect>
              </v-col>
              <v-col v-if="projectsEnabled && Customer.Id" class="mr-3">
                <ProjectSelect v-model="editObject.ProjectId"
                  :label="$t('servicesystem.common_objects.project.project')" :filter="{CustomerIdList: [Customer.Id]}" clearable :externaledit="editMode" @FocusState="editMode ? null : edittrigger++" >
                </ProjectSelect>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="px-3 py-2 mt-2" style="background-color: #ffe8dd;">
                <QTextArea v-model="editObject.ServiceManagerComment"
                  :label="$t('servicesystem.common_objects.job.service_manager_comment')" :backgroundcolor="'#ffe8dd'"
                  :timestampOnFirstLineEnter="globalSettings.OnEnterUserTimestampServiceManagerComment"
                  :singleline="!editObject.ServiceManagerComment"
                  :placeholder="!editObject.ServiceManagerComment ? $t('servicesystem.common_objects.job.service_manager_comment') : undefined"
                  :externaledit="editMode" @FocusState="editMode ? null : edittrigger++">
                </QTextArea>
              </v-col>
            </v-row>
          </v-list>
        </v-container>
      </template>
    </slotted-card>

    <edit-bar :externalTrigger="editMode" :saveable="valid && IsChanged"
      :saveText="$t('servicesystem.common_objects.commonterms.save')" :dividerPos="'none'"
      :class="editMode ? 'mt-1' : null" @saveEmit="save()" @modeEmit="edittrigger++">
    </edit-bar>

  </v-card>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import ProjectSelect from "@/components/Inputs/EntityDropdowns/ProjectSelect2.vue";
import EditBar from "@/components/Sections/Editbar.vue";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import SlottedCard from "@/views/layouts/SlottedCardSection.vue";

export default {
  name: "ParentjobInvoiceOptionsCard",
  props: {},
  components: {
    EditBar,
    SlottedCard,
    ProjectSelect,
    DepartmentSelect
  },
  mixins: [clientAPI],

  data() {
    return {
      valid: false,
      editObject: null,
      copyObject: null,
      edittrigger: 0,
      editMode: false,
      loading: false,

      resettrigger: 0,
    };
  },

  mounted() {
    this.SetDetails();
    this.$store.dispatch("NotificationStore/subscribe", [
      SRConst.EventKeys.OrderChange,
      this.notifyChanges
    ]);
  },

  beforeDestroy() {
    this.$store.dispatch("NotificationStore/unsubscribe", [
      SRConst.EventKeys.OrderChange,
      this.notifyChanges
    ]);
  },

  methods: {
    notifyChanges(args) {
      if (args && args.orderId) {
        if (args.orderId == this.ParentOrder.Id) {
          this.$store.dispatch("JobHub/JobUpdater/triggerUpdateCompleteOrder");
        }
      }
    },

    save() {
      const dto = Object.assign({}, this.editObject);
      this.loading = true;
      //console.log("Final sent: ", dto);
      this.saveParentOrderOptions(dto)
        .then((response) => {
          //console.log("recived: ", response);
          const noinvoiceupdate = { key: "NoInvoice", value: response.NoInvoice };
          this.$store.dispatch("JobHub/JobParentjob/setJobDetail", noinvoiceupdate);
          this.$store.dispatch("JobHub/JobParentjob/setJobOrderField", noinvoiceupdate);
          this.$store.dispatch("JobHub/JobParentjob/setJobDetail", {
            key: "InvoiceReference",
            value: response.InvoiceReference,
          });
          this.$store.dispatch("JobHub/JobParentjob/setJobDetail", {
            key: "ServiceManagerComment",
            value: response.ServiceManagerComment,
          });
          this.$store.dispatch("JobHub/JobParentjob/setJobOrderField", {
            key: "DepartmentId",
            value: response.DepartmentId,
          });
           this.$store.dispatch("JobHub/JobParentjob/setJobOrderField", {
            key: "ProjectId",
            value: response.ProjectId,
          });
          this.edittrigger++;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    setEditMode(bool) {
      this.editMode = bool;
    },

    setValid(bool) {
      this.valid = bool;
    },

    SetDetails() {
      var existingcopy = Object.assign({}, this.ParentOrder);
      var reducedcopy = {
        Id: existingcopy.Id,
        JobId: existingcopy.JobId,
        NoInvoice: existingcopy.NoInvoice,
        InvoiceReference: this.JobDetails.InvoiceReference,
        ServiceManagerComment: this.JobDetails.ServiceManagerComment,
        DepartmentId: existingcopy.DepartmentId,
        ProjectId: existingcopy.ProjectId,
      };

      this.editObject = Object.assign({}, reducedcopy);
      this.copyObject = Object.assign({}, reducedcopy);

    },

    unfocusEntireCard() {
      if (!this.IsChanged && this.editMode) {
        this.edittrigger++;

      }
    },
  },

  computed: {
    JobDetails() {
      return this.$store.getters["JobHub/JobParentjob/JobDetails"];
    },

    Customer() {
      return this.$store.getters["JobHub/Customer"];
    },

    ParentOrder() {
      return this.$store.getters["JobHub/ParentOrder"];
    },

    IsChanged() {
      if (this.editObject && this.copyObject) {
        return !this.SameValue(this.editObject, this.copyObject);
      } else {
        return false;
      }
    },

    globalSettings() {
      return this.$store.state.GlobalSettings;
    },

    projectsEnabled() {
      return this.globalSettings.Features.ProjectsEnabled;
    },

    Subjobs() {
      return this.$store.getters["JobHub/Subjobs"];
    },

    NonUniformNoInvoice() {
      var count = this.Subjobs.filter(
        (x) => (x.NoInvoice && !this.copyObject.NoInvoice) || (!x.NoInvoice && this.copyObject.NoInvoice)
      ).length;

      return count;
    },

    indeterminateText() {
      var string =
        "Default: " +
        (this.editObject.NoInvoice
          ? this.$t("servicesystem.common_objects.commonterms.yes")
          : this.$t("servicesystem.common_objects.commonterms.no")) +
        ". (Except " +
        this.NonUniformNoInvoice +
        "/" +
        this.Subjobs.length +
        ")";

      return string;
    },
  },

  watch: {
    JobDetails: function () {
      this.SetDetails();
    },

    editMode: function (newVal) {
      if (!newVal) {
        this.resettrigger++;
        this.SetDetails();
      }
    },

    editObject: {
      handler(newValue) {
        this.$store.dispatch("JobHub/JobParentjob/setNewJobDetails", newValue);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>